.uiaas-search-voice__record-button {
  --qds-control-small-height: 1.75rem;
}
.uiaas-search-voice__button-wrapper {
  position: relative;
}

.uiaas-search-voice__animation-circle-1 {
  position: absolute;
  width: 21px;
  height: 21px;
  border-radius: 50%;
  top: 12px;
  left: 12px;
  transform: translate(-50%, -50%);
  background-color: transparent;
  pointer-events: none;
  animation: beam-animation 4s infinite;
  animation-timing-function: linear;
  @media (min-width: 980px) {
    top: 6px;
    left: 6px;
  }
}

.uiaas-search-voice__animation-circle-2 {
  @extend .uiaas-search-voice__animation-circle-1;
  animation-delay: 1s;
}

.uiaas-search-voice__animation-circle-3 {
  @extend .uiaas-search-voice__animation-circle-1;
  animation-delay: 2s;
}

@keyframes beam-animation {
  0% {
    transform: scale(1);
    background-color: transparent;
  }
  33% {
    transform: scale(1.8);
    opacity: 0.2;
    background: var(--qds-theme-focus-border, #0075a3);
  }
  67% {
    transform: scale(2.6);
    opacity: 0.1;
  }
  100% {
    transform: scale(3.4);
    opacity: 0;
  }
}
